import React, { useMemo } from "react";
import { RiQuestionnaireFill } from "react-icons/ri";

import { useDispatch } from "react-redux";

// Utility to split the array into random chunks (1 to 3 items per row)
function chunkQuestionsRandomly(questions) {
  const result = [];
  let i = 0;
  while (i < questions.length) {
    const chunkSize = Math.floor(Math.random() * 3) + 1; // 1-3 per row
    result.push(questions.slice(i, i + chunkSize));
    i += chunkSize;
  }
  return result;
}

export default function TemplateQuestions({ questions, handleTemplateSubmit }) {
  const dispatch = useDispatch();

  const groupedQuestions = useMemo(
    () => chunkQuestionsRandomly(questions),
    [questions]
  );

  return (
    <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2  flex flex-col gap-2 items-center max-w-[90vw]">
      {groupedQuestions.map((group, rowIndex) => (
        <div
          key={rowIndex}
          className="flex flex-wrap justify-center gap-2 w-full max-w-4xl">
          {group.map((ele) => (
            <button
              key={ele.key}
              onClick={(e) => {
                e.preventDefault();
                dispatch({ type: "set_ques", payload: ele.que });
                // dispatch({ type: "templeteQuesClick", payload: true })
                handleTemplateSubmit(ele.que);
              }}
              className="cursor-pointer bg-slate-950 text-slate-100 p-2 px-3 rounded-lg flex items-center gap-1 border border-slate-800 hover:bg-slate-800 transition-all duration-200">
              <RiQuestionnaireFill className="w-5 h-5" />
              <span>{ele.que}</span>
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
